// src/globals.js
// CommonJS (compatível). Lê public/env.js (window.__ENV) em runtime.

const ENV = (typeof window !== "undefined" && window.__ENV) ? window.__ENV : {};

module.exports = {
  // Em produção, o Nginx da Hostinger atende /api -> backend Amazon
  BaseApiUrl: ENV.API_BASE || "/api",

  // >>> AQUI é o que importa para o axios.js (usa VendasApiUrl):
  // Pare de fixar o domínio antigo; use sempre /api.
  VendasApiUrl: ENV.VENDAS_HOST || "/api",

  // SSE já vai em /api/evento via Nginx
  SsePath: ENV.SSE_PATH || "/api/evento",

  CieloUrl: ENV.CIELO_URL || "",
  AuthHeaderFormat: ENV.AUTH_HEADER_FORMAT || "raw",
};
